import type React from "react"
import { AddOnBadge } from "./add-on-badge"
import classNames from "classnames"
import { Img } from "components"
import { ReactNode } from "react"

type AddOnFeatureProps = {
  title: string | React.ReactNode
  description: string | React.ReactNode
  cta?: string
  imageAlt: string
  imageQuery: string
  reverse?: boolean
  badge?: ReactNode;
}

export function AddOnFeature({
  title,
  description,
  cta = "Learn More →",
  imageAlt,
  imageQuery,
  reverse,
  badge,
}: AddOnFeatureProps) {
  return (
    <section
      className={classNames(
        "grid items-center gap-8 grid-cols-2",
        "md:grid-cols-1 md:gap-6",
        "sm:gap-5"
      )}
    >
      {/* Text column */}
      <div className={classNames(
        "flex flex-col gap-4 w-[90%]",
        "md:w-full md:order-1",
        reverse ? "order-2" : "order-1"
      )}>
        {!!cta && <AddOnBadge />}
        {!!badge && badge}
        <h3 className="text-[#0C0C0C] text-pretty text-4xl font-semibold tracking-tight md:text-3xl sm:text-2xl">
          {typeof title === "string" ? title : title}
        </h3>
        <div className="text-sm leading-6 text-[#4D4D4D] sm:text-xs sm:leading-5">
          {typeof description === "string" ? <p>{description}</p> : description}
        </div>
        {!!cta && <div>
          <button 
            type="button" 
            className="mt-2 bg-[#0762D7] text-[white] hover:bg-[#0762D7/90] px-4 py-2 rounded-lg text-sm sm:text-xs sm:px-3 sm:py-1.5 transition-colors"
          >
            {cta}
          </button>
        </div>}
      </div>
      {/* Illustration / card column */}
      <div className={classNames(
        "relative",
        "md:order-2",
        reverse ? "order-1" : "order-2"
      )}>
        <div className={classNames(
          "relative w-full overflow-hidden rounded-xl border",
          "bg-card shadow-sm",
          "sm:rounded-lg"
        )}>
          {/* Soft glassy background using placeholder image */}
          <Img
            alt={imageAlt}
            src={`${imageQuery}`}
            className="object-cover w-full h-full"
          />
          {/* Subtle inset border for polish */}
          <div className="pointer-events-none absolute inset-0 rounded-xl ring-1 ring-inset ring-border/60 sm:rounded-lg" />
        </div>
      </div>
    </section>
  )
}